<template>
  <div>
    <div :class="`${el}__row`">
      <Col :l="8" :xl="6" :m="10" :s="12" :xl-offset="3" :l-offset="2" :m-offset="1">
        <InViewAnimation>
          <Headline slot="0" size="xs">
            {{ $t('careLevelCalculator.preWizard.step2.headline') }}
          </Headline>
          <template slot="1">
            <Copy
              size="m"
              v-html="
                $t('careLevelCalculator.preWizard.step2.text1', {
                  link: 'https://www.pflege.de/kundendatenschutzerklaerung/#link6',
                })
              "
            ></Copy>
            <Copy size="m" v-html="$t('careLevelCalculator.preWizard.step2.text2')"></Copy>
            <Copy size="m" v-html="$t('careLevelCalculator.preWizard.step2.text3')"></Copy>
          </template>
        </InViewAnimation>
      </Col>
    </div>
    <Divider dotted />
    <div :class="`${el}__row ${el}__buttonRow`">
      <Link icon="arrow-left-line" :class="`${el}__navLink`" @click="prevPage" noUnderline>
        {{ $t('careLevelCalculator.backButton') }}
      </Link>
      <Button
        :label="$t('careLevelCalculator.landingPage.next.button.label')"
        additionalIconName="arrow-right-line"
        @click="nextStep"
        :expand="!$matchMedia.s"
        small
      />
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Link from '@/objects/Link';
import Divider from '@/objects/Divider';
import Button from '@/objects/Button';
import Col from '@/components/Grid/Col';
import Headline from '@/objects/Headline';
import InViewAnimation from '@/components/InViewAnimation';

import {
  ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD,
  ROUTE_SERVICE_CARELEVEL_CALCULATOR,
} from '@/constants/routes';

export default {
  name: 'Step2',
  components: {
    Copy,
    Link,
    Divider,
    Button,
    Col,
    InViewAnimation,
    Headline,
  },

  data() {
    return {
      el: 'v-careLevelCalculatorPreWizard',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  methods: {
    prevPage() {
      this.$router.push(ROUTE_SERVICE_CARELEVEL_CALCULATOR);
    },
    nextStep() {
      this.$router.push(`${ROUTE_SERVICE_CARELEVEL_CALCULATOR_PREWIZARD}/2`);
      this.$emit(
        'onTrackingClick',
        'Abfrage1/2_btn-' + this.$t('careLevelCalculator.landingPage.next.button.label')
      );
    },
  },
};
</script>
